/**
 * 模块名称: 设备借出申请模块
 * @author zhuyan@372163.com
 */
import React, { useEffect, useState } from 'react'
import { Form, Input, InputNumber, DatePicker, Button, message, Icon } from 'antd'
import moment from 'moment'
import api from '@/api'
import '../assets/module.scss'

const { TextArea } = Input
const FormItem = Form.Item

const BorrowDeviceForm = (props) => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = props.form
  const { setBorrowVisible, getList, borrowType, editId, selectedRowId, setSelectedRows, setSelectedRowKeys } = props
  const [deviceData, setDeviceData] = useState(null)
  const [saveLoading, setSaveLoading] = useState(false)
  const [snCodes, setSnCodes] = useState([]) // 设备SN列表

  // 根据id获取snCodes
  useEffect(() => {
    if (selectedRowId && selectedRowId.length > 0) {
      api.getSnCodeByDeviceId({ deviceIds: selectedRowId.join(','), type: 1 }).then(data => { // 获取snCode编码
        setSnCodes(data || [])
      }).catch(error => {
      })
    }
  }, [])

  // 获取设备借出详情（编辑模式）
  useEffect(() => {
    if (borrowType === 1 && editId) {
      api.getBorrowDetail({ id: editId }).then(data => {
        const { count, departmentName, userName, borrowDate, associatedProject,projectUsedAddress,
          operationMode, expectedReturnDate, contractNumber, borrowDescription, snCodes } = data
        setDeviceData({
          count,
          departmentName,
          userName,
          associatedProject,
          projectUsedAddress,
          operationMode,
          contractNumber,
          borrowDescription,
          borrowDate: borrowDate ? moment(borrowDate) : null,
          expectedReturnDate: expectedReturnDate ? moment(expectedReturnDate) : null,
        })
        setSnCodes(snCodes ? snCodes.split(',') : [])
      })
    }
  }, [editId, borrowType])

  // 填充表单数据
  useEffect(() => {
    if (deviceData) {
      setFieldsValue(deviceData)
    }
  }, [deviceData])

  // 删除 SN 编码
  const handleRemoveSn = (sn) => {
    setSnCodes(snCodes.filter(code => code !== sn))
  }

  // 提交表单
  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        if (snCodes && snCodes.length > values.count) {
          message.success('设备SN编码中设备数量需小于等于借出设备数量')
          return
        }
        const formattedValues = {
          ...values,
          borrowDate: values.borrowDate ? values.borrowDate.format('YYYY-MM-DD') : null,
          expectedReturnDate: values.expectedReturnDate ? values.expectedReturnDate.format('YYYY-MM-DD') : null,
          snCodes: snCodes.join(', '),
        }
        if (editId) {
          formattedValues.id = editId
        }

        setSaveLoading(true)
        api.deviceBorrowApply(formattedValues).then(() => {
          message.success(`借出${borrowType === 1 ? '编辑' : '申请提交'}成功`)
          setSaveLoading(false)
          setBorrowVisible(false)
          getList()
          if (borrowType === 0) {
            setSelectedRows([])
            setSelectedRowKeys([])
          }
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  // 重置表单
  const handleReset = () => {
    resetFields()
    setBorrowVisible(false)
  }

  const formItemLayout = {
    labelCol: { xs: { span: 24 }, sm: { span: 6 } },
    wrapperCol: { xs: { span: 24 }, sm: { span: 16 } }
  }

  return (
    <div className='modulePublic-Apply-container'>
      <Form onSubmit={handleSubmit} {...formItemLayout}>

        <FormItem style={{ marginBottom: 4 }} label="借出设备数量">
          {getFieldDecorator('count', { rules: [{ required: true, message: '请输入借出设备数量' }] })(
            <InputNumber placeholder="请输入借出设备数量" min={1} style={{ width: '100%' }} />
          )}
        </FormItem>
        <FormItem style={{ marginBottom: 4 }} label="使用部门">
          {getFieldDecorator('departmentName', { rules: [{ required: true, message: '请输入设备使用部门' }] })(
            <Input placeholder="请输入设备使用部门名称" />
          )}
        </FormItem>  <FormItem style={{ marginBottom: 4 }} label="使用人">
          {getFieldDecorator('userName', { rules: [{ required: true, message: '请输入设备使用人' }] })(
            <Input placeholder="请输入设备使用人姓名" />
          )}
        </FormItem>
        <FormItem style={{ marginBottom: 4 }} label="借出日期">
          {getFieldDecorator('borrowDate', { rules: [{ required: true, message: '请选择借出日期' }] })(
            <DatePicker placeholder="请选择借出日期" style={{ width: '100%' }} />
          )}
        </FormItem>
        <FormItem style={{ marginBottom: 4 }} label="关联项目">
          {getFieldDecorator('associatedProject', { rules: [{ required: true, message: '请输入设备关联项目' }] })(
            <Input placeholder="请输入设备关联项目" />
          )}
        </FormItem>
        <FormItem style={{ marginBottom: 4 }} label="项目使用地">
          {getFieldDecorator('projectUsedAddress', { rules: [{ required: true, message: '请输入项目使用地' }] })(
            <Input placeholder="请输入项目使用地" />
          )}
        </FormItem>

        <FormItem style={{ marginBottom: 4 }} label="运营方式">
          {getFieldDecorator('operationMode', { rules: [{ required: true, message: '请输入设备运营方式' }] })(
            <Input placeholder="请输入设备运营方式" />
          )}
        </FormItem>

        <FormItem style={{ marginBottom: 4 }} label="预计归还日期">
          {getFieldDecorator('expectedReturnDate', { rules: [{ required: true, message: '请选择设备预计归还日期' }] })(
            <DatePicker placeholder="请选择设备预计归还日期" style={{ width: '100%' }} />
          )}
        </FormItem>

        <FormItem style={{ marginBottom: 4 }} label="合同编号">
          {getFieldDecorator('contractNumber')(
            <Input placeholder="请输入设备借出关联的合同编号" />
          )}
        </FormItem>

        <FormItem style={{ marginBottom: 4 }} label="借出说明">
          {getFieldDecorator('borrowDescription')(
            <TextArea placeholder="请输入借出说明" />
          )}
        </FormItem>

        <FormItem label="设备 SN 编码" style={{ marginBottom: 4 }} className="custom-sn-form-item">
          {getFieldDecorator('snCodes')(
            <div className="sn-container">
              <div className="sn-box">
                {snCodes && snCodes.map((sn, index) => (
                  <div key={index} className="sn-item">
                    <span className="sn-text">{sn}</span>
                    <Icon type="close" className="sn-close" onClick={() => handleRemoveSn(sn)} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </FormItem>

        <FormItem wrapperCol={{ span: 24, style: { textAlign: 'center' } }}>
          <Button onClick={handleReset} style={{ marginRight: 8 }}>取消</Button>
          <Button loading={saveLoading} type="primary" htmlType="submit">确认</Button>
        </FormItem>
      </Form>
    </div>
  )
}

export default Form.create()(BorrowDeviceForm)
